import { createContext } from 'react'

const recruiterModeContext = createContext()

export default recruiterModeContext
